<ul class="accountsList">

  <!-- independent accounts second -->
  @for (account of otherAccounts; track account) {
    @let isAdmin = account.userRole == 2;
    <li>
      @if(account.userRole == 3 && !account.accountRequestKey) {
        <!-- Reviewer without project -->
        <div class="weaveGrid accountsList_item">
          <figure>
              <mat-icon fontSet="material-icons-outlined">rate_review</mat-icon>
          </figure>
          <span class="accountName pageHeader">No Program or Institution to Review</span>
          <span class="accountName_details">Reviewer</span>
        </div>
      } @else {
        <a class="weaveGrid accountsList_item" (click)="switchRole(account.accountRequestKey)">
          <figure>
            @if(account.userRole == 3) {
              <mat-icon fontSet="material-icons-outlined">rate_review</mat-icon>
            } @else if(isAdmin) {
              <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
                <!-- Generator: Adobe Illustrator 30.0.0, SVG Export Plug-In . SVG Version: 2.1.1 Build 123)  -->
                <path d="M10.33,19.15c-.65-.4-1.24-.9-1.78-1.5-.53-.6-.99-1.25-1.36-1.96s-.67-1.45-.88-2.24-.31-1.57-.31-2.35v-4.7l6-2.25,6,2.25v3.67c.35.05.69.13,1.03.24.33.11.66.23.97.36v-5.67l-8-3-8,3v6.1c0,2.53.75,4.84,2.26,6.91,1.51,2.08,3.42,3.4,5.74,3.99.02,0,.03,0,.04-.01,0,0,.02-.01.04-.01-.38-.38-.73-.82-1.03-1.3s-.54-.99-.72-1.52Z"/>
                <polygon points="17.05 15.44 16.39 17.57 17.77 17.57 17.1 15.44 17.05 15.44"/>
                <path d="M17.08,11.91c-2.77,0-5.02,2.25-5.02,5.02s2.25,5.02,5.02,5.02,5.02-2.25,5.02-5.02-2.25-5.02-5.02-5.02ZM18.51,19.93l-.4-1.26h-2.07l-.39,1.26h-1.56l2.02-6h1.93l2.02,6h-1.56Z"/>
              </svg>
            } @else {
              <mat-icon fontSet="material-icons-outlined">groups</mat-icon>
            }
          </figure>
          <span class="accountName pageHeader" [matTooltip]="account.nameToShow">{{account.nameToShow}}</span>
          @if(account.userRole == 3) {
            <span class="accountName_details">Reviewer</span>
          } @else if(isAdmin && account.isFederation) {
            <span class="accountName_details">Administrator</span>
          } @else if(isAdmin && account.isAccreditor) {
            <span class="accountName_details">Administrator</span>
          } @else if(isAdmin && !account.isAccreditor) {
            <span class="accountName_details">Admin</span>
          } @else if(account.isAccreditor) {
            <span class="accountName_details">Manager</span>
          } @else {
            <span class="accountName_details">Team Member</span>
          }
        </a>
      }
    </li>
  }

  <!-- portal accounts last -->
  @for(portal of portals; track portal; let i = $index) {
    <li>
      @if(portal.name) {
      <h2 class="pageHeader portalName">{{portal.name}} Portal</h2>
      }
      <ul class="portalRoles">
        @for(account of portal.accounts; track account; let j = $index) {
          <li>
            @if(account.userRole == 3 && !account.accredProjectRequestKey) {
            <!-- Reviewer without project -->
            <div class="weaveGrid accountsList_item">
              <figure><mat-icon fontSet="material-icons-outlined">rate_review</mat-icon></figure>
              <span class="accountName pageHeader">
                No Program or Institution to Review
              </span>
              <span class="accountName_details">Reviewer</span>
            </div>
          } @else if(account.userRole == 3 && account.accredProjectRequestKey) {
            <!-- Reviewer -->
            <a class="weaveGrid accountsList_item" (click)="setEvaluator(account.accredProjectRequestKey)">
              <figure><mat-icon fontSet="material-icons-outlined">rate_review</mat-icon></figure>
              <span class="accountName pageHeader" [matTooltip]="account.accredProjectName + ', ' + account.accreditorName">
                {{account.accountName}}
              </span>
              <span class="accountName_details">Reviewer</span>
            </a>
          } @else {
            @let isAdmin = account.userRole == 2;
            <a class="weaveGrid accountsList_item" (click)="switchRole(account.accountRequestKey)">
              @if(isAdmin) {
                <figure>
                  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
                    <!-- Generator: Adobe Illustrator 30.0.0, SVG Export Plug-In . SVG Version: 2.1.1 Build 123)  -->
                    <path d="M10.33,19.15c-.65-.4-1.24-.9-1.78-1.5-.53-.6-.99-1.25-1.36-1.96s-.67-1.45-.88-2.24-.31-1.57-.31-2.35v-4.7l6-2.25,6,2.25v3.67c.35.05.69.13,1.03.24.33.11.66.23.97.36v-5.67l-8-3-8,3v6.1c0,2.53.75,4.84,2.26,6.91,1.51,2.08,3.42,3.4,5.74,3.99.02,0,.03,0,.04-.01,0,0,.02-.01.04-.01-.38-.38-.73-.82-1.03-1.3s-.54-.99-.72-1.52Z"/>
                    <polygon points="17.05 15.44 16.39 17.57 17.77 17.57 17.1 15.44 17.05 15.44"/>
                    <path d="M17.08,11.91c-2.77,0-5.02,2.25-5.02,5.02s2.25,5.02,5.02,5.02,5.02-2.25,5.02-5.02-2.25-5.02-5.02-5.02ZM18.51,19.93l-.4-1.26h-2.07l-.39,1.26h-1.56l2.02-6h1.93l2.02,6h-1.56Z"/>
                  </svg>
                </figure>
              } @else {
                <figure><mat-icon fontSet="material-icons-outlined">groups</mat-icon></figure>
              }
              <span class="accountName pageHeader" [matTooltip]="account.nameToShow">{{account.nameToShow}}</span>
              @if(isAdmin && account.isFederation) {
                <span class="accountName_details">Administrator</span>
              }
              @else if(isAdmin && !account.isAccreditor) {
                <span class="accountName_details">Admin</span>
              } @else if(isAdmin && account.isAccreditor) {
                <span class="accountName_details">Administrator</span>
              } @else if(!isAdmin && account.isAccreditor) {
                <span class="accountName_details">Stuff</span>
              } @else {
                <span class="accountName_details">Team Member</span>
              }
            </a>
          }
          </li>
        }
      </ul>
    </li>
  }
  @if(!hasOtherAccounts) {
    <li class="noOtherRoles">No Other Accounts</li>
  }
</ul>
